export default __webpack_public_path__ + "static/media/pl.a9d01805.svg";